module.exports = __webpack_public_path__ + "media/images/dmu-kaikou-offer-f7f4283f1195eb9ce546958ce4fc3212.jpg";